const SECTION_PAGE_TYPES = {
  graphs: '1',
  summary: '2',
  dashboard: '4',
};

export default SECTION_PAGE_TYPES;
